import { useState } from "react";
import { ButtonPrimary } from "../../components/NewButtons";
import { CopyTimeslotsModal } from "./CopyTimeslotsModal";

type Props = {
  wordingType: "import" | "overwrite";
};

export const CopyTimeslotsSelector = ({ wordingType }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ButtonPrimary onClick={() => setIsOpen(true)}>
        {wordingType === "import" ? "Import timeslots" : "Overwrite timeslots"}
      </ButtonPrimary>
      <CopyTimeslotsModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        wordingType={wordingType}
      />
    </>
  );
};
